/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

let PluginSocialSharer = new function(){
    let me = this;

    this.init = function(obj){
        obj.find('[data-sharer]').off('click.sharer').on('click.sharer', function () {
            var type = $(this).data('sharer');
            var url = encodeURI($(this).data('sharer-url'));
            var share;

            switch(type){
                case 'facebook':
                    share = 'https://www.facebook.com/sharer/sharer.php?u='+url;
                    break;
                case 'pinterest':
                    var img = encodeURI($(this).data('sharer-img'));
                    var description = encodeURI($(this).data('sharer-description'));

                    share = 'https://pinterest.com/pin/create/button/?url='+url+'&media='+img+'&description='+description;
                    break;
                case 'google':
                    share = 'https://plus.google.com/share?url='+url;
                    break;
                case 'twitter':
                    var description = encodeURI($(this).data('sharer-description'));

                    share = 'http://twitter.com/share?text='+description+'&url='+url;
                    break;
            }

            if(share){
                var shareWindow = window.open(share, "shareWindow", "width=450,height=250");
            }
        });
    };
};

module.exports = PluginSocialSharer;